import { RoleUser } from './RoleUser';
import { Perspective } from './Perspective';
import { AppName } from './AppName';

export class Role {
  label: string;
  name: string;
  role_users: RoleUser[];
  role_perspectives: Perspective[];
  role_services: AppName[];
  allocation_permission: 'viewer' | 'editor';
  administrator: boolean;

  constructor(data: any) {
    this.label = data.label || '';
    this.name = data.name || '';
    this.role_users = (data.role_users || []).map((u: any) => new RoleUser(u));
    this.role_perspectives = (data.role_perspectives || []).map(
      (v: any) => new Perspective(v)
    );
    this.role_services = (data.role_services || []).map(
      (s: any) => new AppName(s)
    );
    this.allocation_permission = data.allocation_permission || 'editor';
    this.administrator = data.administrator || false;
  }
}
